import React from 'react'

const Overlay = ({children}) => {
    return <div className="sidebar-overlay">
    {children}
    </div>
}

export default Overlay